/**
 * Created by lovely on 2016/6/7.
 */
'use strict';


var _ = require('underscore');
var appTypes = require('../types/appTypes');
var colorHelper = require('./colorHelper');
var util = require('./util');

var MAX_IMGSIZE = 8192;

module.exports = {


  getImageSize: function (img, cb) {
    var newImg = document.createElement('img');
    newImg.src = img.src;
    newImg.style.position = 'absolute';
    newImg.style.left = '-9999px';
    newImg.style.top = '-9999px';
    document.body.appendChild(newImg);
    newImg.onload = function () {
      cb(null, {
        width: this.width || img.naturalWidth || newImg.width,
        height: this.height || img.naturalHeight || newImg.height
      }, newImg);
      document.body.removeChild(newImg);
    };
  },

  setDath: function (ctx, dashArr) {
    if (!dashArr) {
      dashArr = [];
    }
    if (typeof ctx.setLineDash !== 'undefined') {
      ctx.setLineDash(dashArr);
      ctx.lineDashOffset = 0;
    } else if (typeof ctx.mozDash !== 'undefined') {
      ctx.mozDash = dashArr;
      ctx.mozDashOffset = 5;
    }
  },

  initContextStyle: function (ctx, thickness, strokeColor, fillColor, lineMode) {
    var dashArr;
    var s;
    var langDadh;
    var dotDash;
    thickness = thickness || 1;
    s = Math.max(1, thickness / 2);
    langDadh = Math.min(10, 5 * s);
    dotDash = 1;
    if (thickness > 1) {
      dotDash = 0.1;
    }
    if (lineMode === 'dashed') {
      dashArr = [langDadh, langDadh];
    } else if (lineMode === 'dotted') {
      dashArr = [dotDash, langDadh];
    } else if (lineMode === 'dash-dot') {
      dashArr = [langDadh, langDadh, dotDash, langDadh];
    } else if (lineMode === 'dash-dot-dot') {
      dashArr = [langDadh, langDadh, dotDash, langDadh, dotDash, langDadh];
    }
    this.setDath(ctx, dashArr);
    ctx.lineWidth = thickness;
    ctx.strokeStyle = strokeColor;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (fillColor)
      ctx.fillStyle = fillColor;
  },

  drawPath: function (ctx, pathData, params) {
    var thickness = params.thickness || 1;
    var dashMode = params.dashMode || 'solid';
    var borderColor = params.borderColor || '#000';
    var i = 0;
    var data = pathData.data();
    var l = data.length;
    var p;
    var w = ctx.canvas.width;
    var h = ctx.canvas.height;
    this.initContextStyle(ctx, thickness, borderColor, undefined, dashMode);

    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    for (i; i < l; i++) {
      p = data[i];
      if (p.t === 'M') {
        ctx.moveTo(p.x, p.y);
        if ((i === l - 1) || (data[i + 1].t === 'M')) {
          ctx.lineTo(p.x, p.y);
        }
      } else {
        ctx.lineTo(p.x, p.y);
      }
    }
    ctx.stroke();
  },

  drawCurveLine: function (ctx, x1, y1, x2, y2, cx, cy) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    if (_.isUndefined(cx) || _.isUndefined(cy)) {
      ctx.lineTo(x2, y2);
    } else {
      ctx.quadraticCurveTo(cx, cy, x2, y2);
    }
    ctx.stroke();
  },

  drawRect: function (ctx, x, y, w, h, params, isFill) {
    var thickness = params.thickness || 1;
    var dashMode = params.dashMode || 'solid';
    var borderColor = params.borderColor || '#000';
    var fillColor = params.color || 'transparent';
    var offset = thickness / 2;
    this.initContextStyle(ctx, thickness, borderColor, fillColor, dashMode);

    ctx.clearRect(x, y, w, h);
    if (isFill) {
      ctx.rect(x, y, w, h);
      ctx.fill();
    }
    if (params.borderVisible) {

      ctx.moveTo(x + offset, y + offset);
      ctx.lineTo(w - offset, y + offset);
      ctx.stroke();
      ctx.moveTo(w - offset, y + offset);
      ctx.lineTo(w - offset, h - offset);
      ctx.stroke();
      ctx.moveTo(x + offset, h - offset);
      ctx.lineTo(w - offset, h - offset);
      ctx.stroke();
      ctx.moveTo(x + offset, y + offset);
      ctx.lineTo(x + offset, h - offset);
      ctx.stroke();
    }
  },
  /**
   * 绘制形状
   * @param graphics
   * @param props :{
   * {
   *  width : number,
   *  height : number,
   *  borderType:String，
   *  triangleType，
   *  [borderVisible:boolean,]
   *  [borderColor : string,]
   *  [fillColor : string,]
   *  [radius:number,]
   *  [borderWidth:number,]
   *  [borderLeft:boolean,]
   *  [borderRight:boolean,]
   *  [borderTop:boolean,]
   *  [borderBottom:boolean,]
   *  [image:document]
   * }}
   */
  drawShpae: function (graphics, props) {
    var width = props.width;
    var height = props.height;
    var borderType = props.borderType;
    var borderVisible = props.borderVisible || false;
    var borderColor = props.borderColor || '#000';
    var fillColor = props.fillColor || '#fff';
    var radius = props.radius;
    var borderWidth = props.borderWidth || 1;
    var triangleType = props.triangleType;
    var borderLeft = _.isUndefined(props.borderLeft) ? true : props.borderLeft;
    var borderTop = _.isUndefined(props.borderTop) ? true : props.borderTop;
    var borderRight = _.isUndefined(props.borderRight) ? true : props.borderRight;
    var borderBottom = _.isUndefined(props.borderBottom) ? true : props.borderBottom;
    var img = props.image;
    var left = 0;
    var top = 0;

    if (!borderVisible) {
      borderWidth = 0;
    }

    var rect = {};
    util.Rect.setLocation(rect, left, top);
    util.Rect.setSize(rect, width, height);
    //util.Rect.shrink(rect,borderWidth/2,borderWidth/2);
    //window.requestAnimationFrame(function () {
    graphics.clearRect(0, 0, width, height);
    graphics.save();
    if (img) {
      if (borderType !== appTypes.ShapeType.RECTANGLE) {
        graphics.rect(rect.left, rect.top, rect.width, rect.height);
      }
    }

    this.initContextStyle(graphics, borderWidth, borderColor, fillColor, props.dashMode);

    createPath(graphics, rect, radius, borderType, triangleType);
    if (img) {
      graphics.drawNineGridImage(img, left, top, width, height);
      graphics.fill();
    } else {
      graphics.fill();
    }

    util.Rect.shrink(rect, borderWidth / 2, borderWidth / 2);
    createPath(graphics, rect, radius, borderType, triangleType);
    if (borderVisible) {
      if (borderType === appTypes.ShapeType.RECTANGLE && !radius) {
        if (borderLeft) {
          graphics.beginPath();
          graphics.moveTo(rect.left, rect.top);
          graphics.lineTo(rect.left, rect.bottom);
          graphics.stroke();
        }
        if (borderTop) {
          graphics.beginPath();
          graphics.moveTo(rect.left, rect.top);
          graphics.lineTo(rect.right, rect.top);
          graphics.stroke();
        }
        if (borderRight) {
          graphics.beginPath();
          graphics.moveTo(rect.right, rect.top);
          graphics.lineTo(rect.right, rect.bottom);
          graphics.stroke();
        }
        if (borderBottom) {
          graphics.beginPath();
          graphics.moveTo(rect.left, rect.bottom);
          graphics.lineTo(rect.right, rect.bottom);
          graphics.stroke();
        }
      } else {
        graphics.stroke();
      }
    }
    //});
  },

  /***
   * 九宫格绘图，4 个参数缺一不可
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics canvas.getContext('2d')
   * @param img  img Document
   * @param sourceRect9 图片的九宫格裁切区域，格式｛left:number,top:number,right:number,bottom:number｝
   * @param destRect 绘制的目标区域,格式｛left:number,top:number,right:number,bottom:number｝
   */
  drawNineGridImage: function (graphics, img, sourceRect9, destRect) {
    var imgW;
    var imgH;
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    if (!graphics || !img || !sourceRect9 || !destRect) {
      return;
    }

    imgW = img.naturalWidth;
    imgH = img.naturalHeight;
    //左上
    sx = 0;
    sy = 0;
    sw = sourceRect9.left;
    sh = sourceRect9.top;
    dx = sx;
    dy = sy;
    dw = sw;
    dh = sh;
    graphics.clearRect(destRect.left, destRect.top, destRect.right, destRect.bottom);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //顶上
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - (imgW - sw);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //右上
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //左
    sx = 0;
    sy = sourceRect9.top;
    sw = sourceRect9.left;
    sh = sourceRect9.bottom - sy;
    dx = sx;
    dy = sy;
    dw = sw;
    dh = destRect.bottom - (imgH - sh);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //中
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - (imgW - sw);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //右
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //左下
    sx = 0;
    sy = sourceRect9.bottom;
    sw = sourceRect9.left;
    sh = imgH - sy;
    dx = sx;
    dw = sw;
    dh = sh;
    dy = destRect.bottom - dh;
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //底
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - destRect.left;
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //右下
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
  },

  /**
   * 水平三段绘制图片
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param left
   * @param right
   * @param destRect
   */
  drawHorizontalThreeGridImage: function (graphics, img, left, right, destRect) {
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    var imgH = img.naturalHeight;
    var imgW = img.naturalWidth;

    sx = 0;
    sy = 0;
    sw = left;
    sh = imgH;
    dx = destRect.left;
    dy = destRect.top;
    dw = sw;
    dh = destRect.bottom - dy;
    graphics.clearRect(0, 0, dw, dh);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    if (right !== left) {
      sx = left;
      sw = right - left;
      dx = destRect.left + sx;
      dw = destRect.right - destRect.left - (imgW - sw);
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);

      sx = right;
      sw = imgW - sx;
      dx = destRect.right - sw;
      dw = sw;
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    } else {
      sx = left;
      sw = imgW - sx;
      dx = destRect.left + sx;
      dw = destRect.right - left;
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    }
  },

  /**
   * 垂直三段绘制图片
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param top
   * @param bottom
   * @param destRect
   */
  drawVerticalThreeGridImage: function (graphics, img, top, bottom, destRect) {
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    var imgH = img.naturalHeight;
    var imgW = img.naturalWidth;

    sx = 0;
    sy = 0;
    sw = imgW;
    sh = top;
    dx = destRect.left;
    dy = destRect.top;
    dw = destRect.right - destRect.left;
    dh = sh;
    graphics.clearRect(0, 0, dw, dh);
    graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    if (bottom !== top) {
      sy = top;
      sh = bottom - top;
      dy = sy;
      dh = destRect.bottom - destRect.top - (imgH - sh);
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);

      sy = bottom;
      sh = imgH - sy;
      dy = destRect.bottom - sh;
      dh = sh;
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    } else {
      sy = top;
      sh = imgH - sy;
      dy = destRect.top + sy;
      dh = destRect.bottom - top;
      graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    }
  },


  /**
   * 绘制图片，此过程是一个比较耗时的过程，不建议在渲染的过程频繁的绘制
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param color {'#FFF'|#FFFFFF'|'rgba(r,g,b,a)'|null}，如果不为null，则会替换图片的颜色
   * @param sourceRect {{left:(number),right:(number)}|{top:(number),bottom:(number)}|{left:(number),top:(number),right:(number),bottom:(number)}|null}，图片的九宫格拉伸区域
   * @param destRect {{left:(number),top:(number),right:(number),bottom:(number)}|null} ，图片绘制的目标区域
   */
  drawColorImage: function (graphics, img, color, sourceRect, destRect) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    var dw;
    var dh;
    //var sw;
    //var sh;
    //var imgData;
    //var rgb;
    var type = 0;
    var sr = {
      left: 0,
      top: 0,
      right: w,
      bottom: h
    };
    var dr = {
      left: 0,
      top: 0,
      right: w,
      bottom: h
    };
    var self = this;
    this.getImageSize(img, function (err, size, img) {
      if (err) {
        console.error(err);
        return;
      }
      var imgW = size.width;
      var imgH = size.height;
      if (!imgW || !imgH) {
        return;
      }
      if (sourceRect) {
        if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right) && !_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
          type = 1;
        } else if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right)) {
          type = 2;
        } else if (!_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
          type = 3;
        }
        if (!_.isUndefined(sourceRect.left)) {
          sr.left = sourceRect.left;
        }
        if (!_.isUndefined(sourceRect.top)) {
          sr.top = sourceRect.top;
        }
        if (!_.isUndefined(sourceRect.right)) {
          sr.right = sourceRect.right;
        }
        if (!_.isUndefined(sourceRect.bottom)) {
          sr.bottom = sourceRect.bottom;
        }
      }

      if (destRect) {
        if (!_.isUndefined(destRect.left)) {
          dr.left = destRect.left;
        }
        if (!_.isUndefined(destRect.top)) {
          dr.top = destRect.top;
        }
        if (!_.isUndefined(destRect.right)) {
          dr.right = destRect.right;
        }
        if (!_.isUndefined(destRect.bottom)) {
          dr.bottom = destRect.bottom;
        }
      }
      if (destRect) {
        dw = destRect.right - destRect.left;
        dh = destRect.bottom - destRect.top;
      } else {
        dw = imgW;
        dh = imgH;
      }

      //if(sourceRect){
      //  sw = sourceRect.right - sourceRect.left;
      //  sh = sourceRect.bottom  - sourceRect.top;
      //}else{
      //  sw = destRect.right - destRect.left;
      //  sh = destRect.bottom - destRect.top;
      //}
      graphics.clearRect(0, 0, dw, dh);
      graphics.globalCompositeOperation = 'source-over';
      if (type === 0) {
        graphics.drawImage(img, 0, 0, imgW, imgH, 0, 0, dw, dh);
      } else if (type === 1) {
        self.drawNineGridImage(graphics, img, sr, dr);
      } else if (type === 2) {
        self.drawHorizontalThreeGridImage(graphics, img, sr.left, sr.right, dr);
      } else if (type === 3) {
        self.drawVerticalThreeGridImage(graphics, img, sr.top, sr.bottom, dr);
      } else {
        return;
      }
      if (color) {
        //imgData = graphics.getImageData(0,0,dw,dh);
        //replacecolor(imgData.data,color);
        //graphics.putImageData(imgData,0,0);
        graphics.globalCompositeOperation = 'source-in';
        createPath(graphics, {left: 0, top: 0, right: dw, bottom: dh});
        graphics.fillStyle = color;
        graphics.fill();
      }
    });
  },


  drawFilterImage: function (graphics, img, destRect, isRepeat, filterProps, shapeProps, faildcall) {
    var imgData;
    var pixes;
    var width = img.width;
    var height = img.height;
    var imgW = img.naturalWidth || img.width;
    var imgH = img.naturalHeight || img.height;
    var copyPixes;
    var filterType = filterProps.filterType;
    var filterValue = filterProps.filterValue;
    var drawBorder = false;
    var shapeType;
    var radius;
    var triangleType;
    var rect;
    var borderWidth;
    var pat;
    if (destRect) {
      width = destRect.right - destRect.left;
      height = destRect.bottom - destRect.top;
    }

    rect = {
      left: 0,
      top: 0,
      right: width,
      bottom: height
    };

    if (!filterValue) {
      filterValue = 3;
    } else {
      filterValue = filterValue;
    }
    if (shapeProps) {
      shapeType = shapeProps.shapeType;
      radius = shapeProps.radius;
      drawBorder = shapeProps.borderVisible;
      triangleType = shapeProps.triangleType;
      borderWidth = shapeProps.borderWidth;
      if (!borderWidth) {
        borderWidth = 1;
      }
    }
    /*
     "copy"	只绘制新图形，删除其他所有内容。
     "darker"	在图形重叠的地方，颜色由两个颜色值相减后决定。
     "destination-atop"	已有的内容只有在它和新的图形重叠的地方保留。新图形绘制于内容之后。
     "destination-in"	在新图形以及已有画布重叠的地方，已有内容都保留。所有其他内容成为透明的。
     "destination-out"	在已有内容和新图形不重叠的地方，已有内容保留。所有其他内容成为透明。
     "destination-over"	新图形绘制于已有内容的后面。
     "lighter"	在图形重叠的地方，颜色由两种颜色值的加值来决定。
     "source-atop"	只有在新图形和已有内容重叠的地方，才绘制新图形。
     "source-in"	在新图形以及已有内容重叠的地方，新图形才绘制。所有其他内容成为透明。
     "source-out"	只有在和已有图形不重叠的地方，才绘制新图形。
     "source-over"	新图形绘制于已有图形的顶部。这是默认的行为。
     "xor"
     */

    graphics.globalCompositeOperation = 'copy';
    //graphics.clearRect(0, 0, width, height);
    //生成一个裁切区的像素数据
    //if (shapeType) {
    //  if (radius) {
    //    radius = parseInt(radius, 10);
    //  }
    //  if (shapeType !== appTypes.ShapeType.RECTANGLE || radius) {
    //    graphics.fillStyle = 'rgba(255,255,255,1)';
    //    createPath(graphics, rect, radius, shapeType);
    //    graphics.fill();
    //    graphics.globalCompositeOperation = 'source-in';
    //  }
    //}
    if (imgW > MAX_IMGSIZE || imgH > MAX_IMGSIZE) {
      if (faildcall) {//超大图片直接不绘制
        faildcall();
      }
      return;
    }
    if (!isRepeat) {
      graphics.drawImage(img, 0, 0, imgW, imgH, 0, 0, width, height);
    } else {
      pat = graphics.createPattern(img, 'repeat');
      graphics.fillStyle = pat;
      graphics.rect(0, 0, width, height);
      graphics.fill();
    }
    //获取原图数据

    if (shapeType) {
      if (radius) {
        radius = parseInt(radius, 10);
      }
      if (shapeType !== appTypes.ShapeType.RECTANGLE || radius) {
        graphics.globalCompositeOperation = 'destination-in';
        graphics.fillStyle = 'rgba(255,255,255,1)';
        createPath(graphics, rect, radius, shapeType);
        graphics.fill();

      }
    }

    try {
      //在本地运行时，这个函数会报错，此时就不再执行后面的代码了。
      imgData = graphics.getImageData(0, 0, width, height);
    } catch (e) {
      if (faildcall) {
        faildcall();
      }
      return;
    }
    pixes = imgData.data;


    if (filterType && filterType !== appTypes.ImageFilter.NONE) {
      //灰度处理
      util.Bitmap.gay(pixes);
      //discolor(pixes);//去色
      if (filterType !== appTypes.ImageFilter.MONO) {
        //复制一份
        //graphics.clearRect(0, 0, width, height);
        graphics.putImageData(imgData, 0, 0);
        copyPixes = graphics.getImageData(0, 0, width, height).data;
        //反相
        util.Bitmap.invert(copyPixes);
        // 高斯模糊
        util.Bitmap.gaussBlur(copyPixes, width, height, filterValue);
        //草图效果处理
        if (filterType === appTypes.ImageFilter.SKETCH) {
          // 实色混合
          util.Bitmap.hardMix(pixes, copyPixes);
        }
        //溶解
        util.Bitmap.dissolve(copyPixes, filterValue);
        //颜色减淡
        util.Bitmap.dodgeColor(pixes, copyPixes);
      }
    }
    //graphics.clearRect(0, 0, width, height);
    graphics.putImageData(imgData, 0, 0);

    if (drawBorder) {
      graphics.globalCompositeOperation = 'source-over';
      graphics.lineWidth = borderWidth;
      graphics.strokeStyle = '#444';
      rect.left = rect.left + borderWidth / 2;
      rect.top = rect.top + borderWidth / 2;
      rect.right = rect.right - borderWidth / 2;
      rect.bottom = rect.bottom - borderWidth / 2;
      createPath(graphics, rect, radius, shapeType, triangleType);
      graphics.stroke();
    }
  }
};

/**
 * 根据需要绘制的形状，生成一个路径区域，该函数不负责区域的填充
 * @param graphics
 * @param rect ｛left:number,top:number,right:number,bottom:number｝
 * @param radius number
 * @param borderType string
 * @param triangleType string
 */
function createPath(graphics, rect, radius, borderType, triangleType) {
  if (rect) {
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.center = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  }
  if (!borderType) {
    borderType = appTypes.ShapeType.RECTANGLE;
  }
  graphics.beginPath();
  if (borderType === appTypes.ShapeType.RECTANGLE) {
    if (radius) {

      graphics.moveTo(rect.left + radius, rect.top);
      graphics.lineTo(rect.right - radius, rect.top);

      ////graphics.arcTo(rect.right-radius,rect.top,rect.right,rect.top + radius,radius);
      //graphics.arc(rect.right - radius,rect.top + radius,radius,0,90);
      graphics.quadraticCurveTo(rect.right, rect.top, rect.right, rect.top + radius);
      graphics.lineTo(rect.right, rect.bottom - radius);
      graphics.quadraticCurveTo(rect.right, rect.bottom, rect.right - radius, rect.bottom);
      graphics.lineTo(rect.left + radius, rect.bottom);
      graphics.quadraticCurveTo(rect.left, rect.bottom, rect.left, rect.bottom - radius);
      graphics.lineTo(rect.left, rect.top + radius);
      graphics.quadraticCurveTo(rect.left, rect.top, rect.left + radius, rect.top);
    } else {
      graphics.rect(rect.left, rect.top, rect.width, rect.height);
    }
  }
  //椭圆
  else if (borderType === appTypes.ShapeType.ELLIPSE) {
    graphics.moveTo(rect.left, rect.center.y);
    graphics.bezierCurveTo(rect.left, rect.top + rect.height * 0.22662, rect.left + rect.width * 0.22662, rect.top, rect.center.x, rect.top);
    graphics.bezierCurveTo(rect.left + rect.width * 0.77338, rect.top, rect.right, rect.top + rect.height * 0.22662, rect.right, rect.center.y);
    graphics.bezierCurveTo(rect.right, rect.top + rect.height * 0.77338, rect.left + rect.width * 0.77338, rect.bottom, rect.center.x, rect.bottom);
    graphics.bezierCurveTo(rect.left + rect.width * 0.22662, rect.bottom, rect.left, rect.top + rect.height * 0.77338, rect.left, rect.center.y);
  }
  //菱形
  else if (borderType === appTypes.ShapeType.DIAMOND) {
    graphics.moveTo(rect.center.x, rect.top);
    graphics.lineTo(rect.right, rect.center.y);
    graphics.lineTo(rect.center.x, rect.bottom);
    graphics.lineTo(rect.left, rect.center.y);
  }
  // 平行四边形
  else if (borderType === appTypes.ShapeType.PARALLELOGRAM) {
    graphics.moveTo(rect.left + rect.width * 0.2, rect.top);
    graphics.lineTo(rect.right, rect.top);
    graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);
    graphics.lineTo(rect.left, rect.bottom);
  }
  //三角形
  else if (borderType === appTypes.ShapeType.TRIANGLE) {
    if (triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
      graphics.moveTo(rect.right, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.center.y);
      graphics.lineTo(rect.right, rect.top);

    } else if (triangleType === appTypes.RotationAngle.NINETY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.center.y);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else if (triangleType === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.top);
      graphics.lineTo(rect.center.x, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else {
      graphics.moveTo(rect.center.x, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.center.x, rect.top);
    }
  }
  //五角星
  else if (borderType === appTypes.ShapeType.STAR) {
    graphics.moveTo(rect.left + rect.width * 0.5, rect.top);
    graphics.lineTo(rect.left + rect.width * 0.66, rect.top + rect.height * 0.33);
    graphics.lineTo(rect.left + rect.width, rect.top + rect.height * 0.38);
    graphics.lineTo(rect.left + rect.width * 0.75, rect.top + rect.height * 0.63);
    graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);

    graphics.lineTo(rect.left + rect.width * 0.5, rect.top + rect.height * 0.83);
    graphics.lineTo(rect.left + rect.width * 0.2, rect.bottom);
    graphics.lineTo(rect.left + rect.width * 0.25, rect.top + rect.height * 0.63);
    graphics.lineTo(rect.left, rect.top + rect.height * 0.36);
    graphics.lineTo(rect.left + rect.width * 0.34, rect.top + rect.height * 0.33);

    graphics.lineTo(rect.left + rect.width * 0.5, rect.top);
  }
  graphics.closePath();
}




/** WEBPACK FOOTER **
 ** ./src/helper/graphicsHelper.js
 **/